export default __webpack_public_path__ + "static/media/charging-point-thumbnail.08468dc9.svg";